import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {ManagedAccountsSearchCriteria} from '../typedef';
import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';
import type {GetManagedAccountIdsRequestFilters} from 'src/openapi/admin/models/GetManagedAccountIdsRequestFilters';
import type {LicenseSearchInfo} from 'src/openapi/admin/models/LicenseSearchInfo';


export const accountSearchResultLicenseSlice = getCachedTableDataSlice<
    Record<string, LicenseSearchInfo>,
    ManagedAccountsSearchCriteria,
    AccountSortField,
    GetManagedAccountIdsRequestFilters & AccountSearchFiltering
>('assignedAccountsSearchResultLicense');

export const accountSearchResultLicenseActions = accountSearchResultLicenseSlice.actions;

const accountSearchResultLicenseCacheSelector: CachedTableCacheSelector<Record<string, LicenseSearchInfo>>
    = state => state.userPage.tabs.assignedAccounts.license.cache;
export const accountSearchResultLicenseDataSelector: CachedTableDataSelector<Record<string, LicenseSearchInfo>>
    = state => state.userPage.tabs.assignedAccounts.license;
export const accountSearchResultLicenseResultSelector = getCachedTableResultSelector(
    accountSearchResultLicenseCacheSelector,
    accountSearchResultStateSelector,
);
